import { type FilterA7FIAIssuerTSSchema, FilterA7FIAIssuerTS } from "./filter";
import { type A7FIAIssuerTS, getIssuerTsColumns } from "./columns";
import { Table } from "@/pages/a7/Table";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

const table_name = "a7_fia_issuer_ts";

export const A7FIAIssuerTSTable = () => {
  const { t, i18n } = useTranslation(["tables", "common"]);
  const columns = useMemo(() => getIssuerTsColumns(t), [t, i18n.language]);

  return (
    <Table<A7FIAIssuerTS, FilterA7FIAIssuerTSSchema>
      label={t(`${table_name}.title`, {
        ns: "tables",
        defaultValue: "Issuer time series",
      })}
      client="a7"
      table_name={table_name}
      columns={columns}
      filter={<FilterA7FIAIssuerTS client="a7" table_name={table_name} />}
    />
  );
};
